import React from 'react';
import { Page } from '../layout';

const NoPermissionsPage = () => {
  const pageTitle = 'Permissions';
  return (
    <Page title={pageTitle}>
      <div>
        This account does not have permission to access this page.
        <br />
        If this is not expected, please contact your sponsor or ISACA at{' '}
        <a href='mailto:VIP@isaca.org'>VIP@isaca.org</a>
      </div>
    </Page>
  );
};

export default NoPermissionsPage;
